export default {
    setFavorites(state, data) {
        state.favorites = data
    },
    setNotes(state, data) {
        state.notes = data.notes
    }
}
